import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import img1 from "../assets/main.png";
import "./homepage.css";
import table from "../assets/table.jpg";
import cupboard from "../assets/cupboard.jpg";
import rack from "../assets/rack.jpg";
import tvunit from "../assets/tvunit.jpg";
import table1img from "../assets/tables/t1.jpg";
import table2img from "../assets/tables/t2.jpg";
import table3img from "../assets/tables/t3.jpg";
import table4img from "../assets/tables/t4.jpg";
import rack1img from "../assets/racks/r1.jpg";
import rack2img from "../assets/racks/r2.jpg";
import rack3img from "../assets/racks/r3.jpg";
import rack4img from "../assets/racks/r4.jpg";
import cb1img from "../assets/cupboard/c1.jpg";
import cb2img from "../assets/cupboard/c2.jpg";
import cb3img from "../assets/cupboard/c3.jpg";
import cb4img from "../assets/cupboard/c4.jpg";
import tv1img from "../assets/tvunits/tv1.jpg";
import tv2img from "../assets/tvunits/tv2.jpg";
import tv3img from "../assets/tvunits/tv3.jpg";
import tv4img from "../assets/tvunits/tv4.jpg";
import logo from "../assets/logo/logo.png";
import '@fortawesome/fontawesome-free/css/all.min.css';


function Homepage() {


  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_9yharof', 'template_g9y8g75', form.current, {
        publicKey: 'i5Box3YAA_OfKxG0H',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };


  return (
    <>
      <nav class="navbar navbar-expand-lg center">
        <div class="container-fluid">
          <a class="navbar-brand" href="#">
            <img src={logo} alt="uyguygyyu" className="logo"/>
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarText"
            aria-controls="navbarText"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon">...</span>
          </button>
          <div class="collapse navbar-collapse" id="navbarText">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="#">
                  Home
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="#products">
                  Products
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div
        id="carouselExampleIndicators"
        class="carousel slide"
        data-bs-ride="carousel"
      >
        <div class="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="0"
            class="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              src={img1}
              class="d-block w-100"
              alt="main"
              style={{ height: "400px", objectFit: "cover" }}
            />
          </div>
          <div class="carousel-item">
            <img
              src={img1}
              class="d-block w-100"
              alt="main"
              style={{ height: "400px", objectFit: "cover" }}
            />
          </div>
          <div class="carousel-item">
            <img
              src={img1}
              class="d-block w-100"
              alt="main"
              style={{ height: "400px", objectFit: "cover" }}
            />
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>

      <div className="products-title">
        <a name="products"></a>
        <h1>Our Best Selling Product</h1>
      </div>
      <div className="cards">
        <a href="#tables">
          <div class="card bg-dark text-white product-card">
            <img src={table} class="card-img" alt="..." />
            <div class="card-img-overlay">
              <h5 class="card-title">Tables</h5>
              {/* <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
    <p class="card-text">Last updated 3 mins ago</p> */}
            </div>
          </div>
        </a>

        <a href="#racks">
          <div class="card bg-dark text-white product-card">
            <img src={rack} class="card-img" alt="..." />
            <div class="card-img-overlay">
              <h5 class="card-title">Racks</h5>
              {/* <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
    <p class="card-text">Last updated 3 mins ago</p> */}
            </div>
          </div>
        </a>

        <a href="#cupboards">
          <div class="card bg-dark text-white product-card">
            <img src={cupboard} class="card-img" alt="..." />
            <div class="card-img-overlay">
              <h5 class="card-title">Cupboards</h5>
              {/* <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
    <p class="card-text">Last updated 3 mins ago</p> */}
            </div>
          </div>
        </a>

        <a href="#tvunits">
          <div class="card bg-dark text-white product-card">
            <img src={tvunit} class="card-img" alt="..." />
            <div class="card-img-overlay">
              <h5 class="card-title">Tv-Units</h5>
              {/* <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
    <p class="card-text">Last updated 3 mins ago</p> */}
            </div>
          </div>
        </a>
      </div>

      <a name="tables"></a>
      <div className="container-fluid racksection">
        <div className="row">
          {/* Left Side Div */}
          <div className="col-lg-6 left-side tablessection">
            <h2 className="products-title">Best Selling Tables</h2>
            <p>
              This is the description text that can go under the main title. Add
              more details here to describe the content.
            </p>
            <p>
              Designed for both style and functionality, our study table
              combines sleek aesthetics with practical storage solutions.
            </p>
            <p>
              {" "}
              Whether you’re working on your laptop or organizing your study
              materials, experience unparalleled comfort and efficiency.
            </p>
            <p>
              Elevate your productivity and add a touch of elegance to your home
              office with our top-of-the-line study table.
            </p>
          </div>

          {/* Right Side Div */}
          <div className="col-lg-6 right-side d-flex flex-wrap justify-content-around align-items-center tablessection">
            <div className="image-box">
              <img src={table1img} alt="Image 1" className="square-image" />
            </div>
            <div className="image-box">
              <img src={table2img} alt="Image 2" className="square-image" />
            </div>
            <div className="image-box">
              <img src={table3img} alt="Image 3" className="square-image" />
            </div>
            <div className="image-box">
              <img src={table4img} alt="Image 4" className="square-image" />
            </div>
          </div>
        </div>
      </div>

      <a name="racks"></a>
      <div className="container-fluid tablessectionmain">
        <div className="row">
          {/* Left Side Div */}
          <div className="col-lg-6 left-side tablessection">
            <h2 className="products-title">Best Selling Racks</h2>
            <p>
              Maximize your space with our premium bookshelf and storage racks,
              designed to offer both functionality and style.
            </p>
            <p>
              Perfectly crafted for modern homes, our storage solutions
              seamlessly blend into any room, keeping your books and essentials
              organized in style.
            </p>
            <p>
              Whether you're arranging your favorite novels or need extra space
              for your decor items, our shelves provide the durability and
              aesthetics you need.
            </p>
            <p>
              Elevate your living space and enjoy clutter-free, efficient
              storage with our high-quality bookshelf and storage rack
              collection.
            </p>
          </div>

          {/* Right Side Div */}
          <div className="col-lg-6 right-side d-flex flex-wrap justify-content-around align-items-center tablessection">
            <div className="image-box">
              <img
                src={rack1img}
                alt="Image 1"
                className="square-image big-rack"
              />
            </div>
            <div className="image-box ">
              <img
                src={rack2img}
                alt="Image 2"
                className="square-image big-rack"
              />
            </div>
            <div className="image-box ">
              <img
                src={rack3img}
                alt="Image 3"
                className="square-image big-rack"
              />
            </div>
            <div className="image-box ">
              <img
                src={rack4img}
                alt="Image 4"
                className="square-image big-rack"
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        <h1 className="products-title"> Best Selling Cupboards</h1>
      </div>
      <a name="cupboards"></a>
      <div>
        <div className=" flex-wrap justify-content-around align-items-center cupboardsection">
          <div className="image-box">
            <img
              src={cb1img}
              alt="Image 1"
              className="square-image big-cupboard"
            />
          </div>
          <div className="image-box ">
            <img
              src={cb2img}
              alt="Image 2"
              className="square-image big-cupboard"
            />
          </div>
          <div className="image-box ">
            <img
              src={cb3img}
              alt="Image 3"
              className="square-image big-cupboard"
            />
          </div>
          <div className="image-box ">
            <img
              src={cb4img}
              alt="Image 4"
              className="square-image big-cupboard"
            />
          </div>
        </div>
      </div>

      <div>
        <h1 className="products-title"> Best Selling TV-Units</h1>
      </div>
      <a name="tvunits"></a>
      <div>
        <div className=" flex-wrap justify-content-around align-items-center cupboardsection">
          <div className="image-box">
            <img
              src={tv1img}
              alt="Image 1"
              className="square-image big-cupboard"
            />
          </div>
          <div className="image-box ">
            <img
              src={tv2img}
              alt="Image 2"
              className="square-image big-cupboard"
            />
          </div>
          <div className="image-box ">
            <img
              src={tv3img}
              alt="Image 3"
              className="square-image big-cupboard"
            />
          </div>
          <div className="image-box ">
            <img
              src={tv4img}
              alt="Image 4"
              className="square-image big-cupboard"
            />
          </div>
        </div>
      </div>
















      <div class="container">
          <div class="row justify-content-md-center">
            <div class="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
              <a name="contact"></a>
              <h1 class="products-title">Contact</h1>
              <p class="text-secondary text-center products-para">The best way to contact us is to use our contact form below.</p>
              <hr class="w-50 mx-auto mb-xl-9 border-dark-subtle"/>
            </div>
          </div>
        </div>


      <div class="main-container">
    <div class="half-width">
      <section class="bg-light py-3 py-md-5 bg-white">
        

        <div class="container bg-white">
          <div class="row justify-content-lg-center bg-white">
            <div class="col-12 col-lg-9 ">
              <div class="bg-white border rounded shadow-sm overflow-hidden">
                <form form ref={form} onSubmit={sendEmail}>
                  <div class="row gy-4 gy-xl-5 p-4 p-xl-5">
                    <div class="col-12">
                      <label for="fullname" class="form-label">Full Name <span class="text-danger">*</span></label>
                      <input type="text" name="to_name"  class="form-control" id="fullname" required />
                    </div>
                    <div class="col-12">
                      <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                      <div class="input-group">
                        <span class="input-group-text">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                    </svg>
                        </span>
                        <input type="email" class="form-control" id="email" name="from_name" required />
                      </div>
                    </div>
                    {/* <div class="col-12 col-md-6">
                      <label for="phone" class="form-label">Phone Number</label>
                      <div class="input-group">
                        <span class="input-group-text">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                    </svg>
                        </span>
                        <input type="tel" class="form-control" id="phone" name="phone" />
                      </div>
                    </div> */}
                    <div class="col-12">
                      <label for="message" class="form-label">Message <span class="text-danger">*</span></label>
                      <textarea class="form-control" id="message" name="message"  rows="3" required></textarea>
                    </div>
                    <div class="col-12">
                      <div class="d-grid">
                      <input class="btn btn-primary btn-lg" type="submit" value="Send" />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="half-width">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d587.3892313455772!2d75.69933311303497!3d16.189939772216373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc779ba691c4ced%3A0x92cc0b0f4b8d8cee!2sCity%20furniture!5e0!3m2!1sen!2sin!4v1726206098507!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" 
      style={{ overflowX: "scroll", width: "100%", height: "400px" }}></iframe>    </div>
  </div>











 
<footer class="text-center text-lg-start bg-body-tertiary text-muted">

  <section class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">

    <div class="me-5 d-none d-lg-block">
      <span>Get connected with us on social networks:</span>
    </div>
  


    <div>
      {/* <a href="plyhouse.store" class="me-4 text-reset">
        <i class="fab fa-google"></i>
      </a> */}
      <a href="https://www.instagram.com/plyhouse_furniture" style={{fontSize:"40px"}} class="me-4 text-reset" target="_blank">
        <i class="fab fa-instagram"></i>
      </a>
      {/* <a href="" class="me-4 text-reset">
        <i class="fab fa-linkedin"></i>
      </a> */}
    </div>
   
  </section>

  <section class="">
    <div class="container text-center text-md-start mt-5">

      <div class="row mt-3">
    
        <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
          
          <h6 class=" fw-bold mb-4">
            <i class="fas fa-gem me-3"></i>PlyHouse Furniture
          </h6>
          <p style={{textAlign:"justify"}}>
          Stylish furniture that simplifies your life. At our store, 'Zindgi kar de aasan' ensures comfort and ease every day.
          </p>
        </div>
        
        <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
       
          <h6 class="text-uppercase fw-bold mb-4">
            Products
          </h6>
          <p>
            <a href="#tables" class="text-reset">Tables</a>
          </p>
          <p>
            <a href="#racks" class="text-reset">Racks</a>
          </p>
          <p>
            <a href="#cupboards" class="text-reset">Cupboards</a>
          </p>
          <p>
            <a href="#tvunits" class="text-reset">TV-Units</a>
          </p>
        </div>
        
        {/* <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
         
          <h6 class="text-uppercase fw-bold mb-4">
            Useful links
          </h6>
          <p>
            <a href="#!" class="text-reset">Pricing</a>
          </p>
          <p>
            <a href="#!" class="text-reset">Settings</a>
          </p>
          <p>
            <a href="#!" class="text-reset">Orders</a>
          </p>
          <p>
            <a href="#!" class="text-reset">Help</a>
          </p>
        </div>
        */}
        <div class="col-md-4 col-lg-3 col-xl-4 mx-auto mb-md-0 mb-4">
          
          <h6 class="text-uppercase fw-bold mb-4" style={{textAlign:"center"}}>Contact</h6>
          <p><i class="fas fa-home me-3"></i>Near Krishna talkies Bagalkot, Karnataka</p>
          <p>
            <i class="fas fa-envelope me-3"></i>
            plyhousefurniture@gmail.com
          </p>
          <p><i class="fas fa-phone me-3"></i>9538335020</p>
        </div>
        
      </div>
    </div>
  </section>
  
  <div class="text-center p-4" style={{backgroundColor:"rgba(0, 0, 0, 0.05)"}}>
    © 2024 Copyright:
    <a class="text-reset fw-bold" href="https://plyhouse.com/">plyhouse.store</a>
  </div>
 
</footer>

          </>
  );
}

export default Homepage;
